import { render, staticRenderFns } from "./InvoiceLineItems.vue?vue&type=template&id=252242b1&"
import script from "./InvoiceLineItems.vue?vue&type=script&lang=js&"
export * from "./InvoiceLineItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports